import {CSSProperties} from "react";
import {Letter} from "@game/map/letter";
import {LETTER_THEME} from "@components/core/theme";
import {selectDebug} from "@redux/selectors/debug";
import {connect} from "react-redux";
import {IDebug} from "@redux/slices/debug";
import {BONUS_COLOURS} from "@components/map/PlaceView";

const styles: Record<string, CSSProperties> = {
    bonus: {
        borderStyle: "dotted"
    },
    content: {
        ...LETTER_THEME.container,
        alignItems: "center",
        borderRadius: 8,
        display: "flex",
        justifyContent: "center"
    },
    contentDragging: {
        transform: "scale(1.05)",
        boxShadow: "8px 8px 8px rgba(0, 0, 0, 0.5)",
        filter: "drop-shadow(8px, 8px)"
    },
    letter: {
        ...LETTER_THEME.content,
        pointerEvents: "none"
    },
    letterNew: {
        color: "#000000"
    },
    letterOld: {
        color: "#434343"
    },
    letterAncient: {
        color: "#838383"
    },
    masked: {
        maskComposite: "intersect",
        maskMode: "luminance",
        maskPosition: "center",
        maskSize: "100%"
    },
    placed: {
        backgroundColor: "lightgrey",
        borderBottom: "slategray solid 3px",
        borderRight: "slategray solid 3px",
        transform: "translate(-2px, -2px)"
    },
    user: {
        backgroundColor: "white"
    }
};

interface ITileView {
    bonus?: number
    debug: IDebug
    dragging: boolean
    letter: Letter,
    onClick?: (letter: Letter) => void
}

function TileView({bonus, dragging, letter, onClick}: ITileView) {
    const contentStyle = {
        ...styles.content,
        ...dragging ? styles.contentDragging
            : letter.placed === null      ? styles.user
            : letter.placed === undefined ? {...styles.placed, ...styles.user}
            : styles.placed
    };
    const bonusStyle = bonus ? {
        ...styles.bonus,
        borderColor: BONUS_COLOURS[bonus]
    } : {};
    const letterStyle = {
        ...styles.letter,
        ...bonusStyle,
        ...styles.letterNew
    };
    const handleClick = () => {
        onClick && onClick(letter)
    }

    return (
        <div style={contentStyle} onClick={handleClick}>
            <span style={letterStyle}>{letter.letter}</span>
        </div>
    );
}
const mapStateToProps = (store: never) => ({
    debug: selectDebug(store)
});
const connected = connect(mapStateToProps, {
})(TileView);
export {connected as TileView}
